module.exports = __webpack_public_path__ + "img/why1.f757a3f5.png";